// extracted by mini-css-extract-plugin
export default {"card":"styles_card__8hvsS","version":"styles_version__1s34a"};